import { css } from '@emotion/react';
import { useLayoutEffect, useRef, useState } from 'react';

export const ACCESS_STATISTICS_LABEL_FONT_SIZE = 15;

export const overviewCardStyle = css`
  height: 100%;
  min-width: 0;
  border-radius: 2px;
  border: 1px solid #f0f0f0;
  box-shadow: none;

  > .ant-card-body {
    height: 100%;
    padding: 0;
  }

  > .ant-card-body > .ant-spin-nested-loading,
  > .ant-card-body > .ant-spin-nested-loading > .ant-spin-container {
    height: 100%;
    min-height: 0;
  }

  > .ant-card-body > .ant-spin-nested-loading > .ant-spin-container {
    display: flex;
    flex-direction: column;
  }
`;

export const overviewCardHeaderStyle = css`
  flex: 0 0 auto;
  text-align: center;
  padding: clamp(16px, 1.4085cqw, 32px) clamp(20px, 1.7606cqw, 40px);
  border-bottom: 1px solid #f0f0f0;
  font-weight: 600;
  font-size: 18.4px;
  line-height: 1.5;
  color: #262626;
`;

export const overviewChartAreaStyle = css`
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  position: relative;
`;

export const overviewTrendHeaderStyle = css`
  padding-top: clamp(8px, 0.7042cqw, 16px);
  padding-bottom: clamp(8px, 0.7042cqw, 16px);
`;

export function useOverviewChartSize() {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;

    const updateSize = () => {
      const width = element.clientWidth;
      const height = element.clientHeight;
      setSize(current => current.width === width && current.height === height
        ? current
        : { width, height });
    };
    updateSize();
    const observer = new ResizeObserver(updateSize);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { ref, ...size };
}
